module.exports = __webpack_public_path__ + "static/img/banner-02.62f9c86d.jpg";